import React from "react";
import { withStyles } from "@material-ui/core/styles";

import { Bar as BarChart } from "react-chartjs-2";

import { registerBackgroundColourService } from "../lib/chartUtils";

registerBackgroundColourService();

type SalesTodayChartProps = {
  classes: Object,
  data: Array<Object>,
};

const basicChartOptions = {
  maintainAspectRatio: false,
  scales: {
    xAxes: [
      {
        ticks: {
          autoSkip: false,
        },
      },
    ],
  },
  chartArea: {
    backgroundColor: "rgba(245, 245, 245, 0.4)",
  },
};

const smallOptions = {
  scales: {
    yAxes: [
      {
        ticks: {
          stepSize: 1,
          beginAtZero: true,
        },
      },
    ],
    xAxes: [
      {
        ticks: {
          autoSkip: false,
        },
      },
    ],
  },
};

const calcOptions = data => {
  const max = data.reduce((a, b) => Math.max(a, b.sales), 0);
  if (max < 5) {
    const options = {
      ...basicChartOptions,
      ...smallOptions,
    };
    return options;
  }
  return basicChartOptions;
};

const mapData = data => ({
  labels: data.map(d => d.title),
  datasets: [
    {
      label: "Ventes aujourd'hui par borne",
      data: data.map(d => d.sales),
      backgroundColor: [
        "rgba(0,63,92,0.7)",
        "rgba(47,75,124,0.7)",
        "rgba(102,81,145,0.7)",
        "rgba(160,81,149,0.7)",
        "rgba(212,80,135,0.7)",
        "rgba(249,93,106,0.7)",
        "rgba(255,124,67,0.7)",
        "rgba(255,166,0,0.7)",
        "rgba(73,143,49,0.7)",
        "rgba(131,175,112,0.7)",
        "rgba(186,208,175,0.7)",
      ],
      borderColor: [
        "rgba(0,63,92,1.0)",
        "rgba(47,75,124,1.0)",
        "rgba(102,81,145,1.0)",
        "rgba(160,81,149,1.0)",
        "rgba(212,80,135,1.0)",
        "rgba(249,93,106,1.0)",
        "rgba(255,124,67,1.0)",
        "rgba(255,166,0,1.0)",
        "rgba(73,143,49,1.0)",
        "rgba(131,175,112,1.0)",
        "rgba(186,208,175,1.0)",
      ],
    },
  ],
});

const SalesTodayChart = ({ classes, data }: SalesTodayChartProps) =>
  data.length > 0 && (
    <div className={classes.container}>
      <BarChart data={mapData(data)} options={calcOptions(data)} height={400} />
    </div>
  );

const styles = () => ({
  container: {
    marginTop: 20,
    marginLeft: 10,
    marginRight: 10,
    maxWidth: 800,
  },
});

export default withStyles(styles)(SalesTodayChart);



// WEBPACK FOOTER //
// ./src/components/salesByKioskTodayChart.js